import './confirm-modal.css'

export function showConfirm(message, options = {}) {
  return new Promise((resolve) => {
    // Create modal overlay
    const overlay = document.createElement('div')
    overlay.className = 'confirm-overlay'
    
    // Create modal
    const modal = document.createElement('div')
    modal.className = 'confirm-modal'
    
    const {
      title = 'Confirm',
      confirmText = 'OK',
      cancelText = 'Cancel',
      confirmClass = 'confirm-btn-primary',
      cancelClass = 'confirm-btn-secondary'
    } = options
    
    modal.innerHTML = `
      <div class="confirm-header">
        <h3>${title}</h3>
      </div>
      <div class="confirm-body">
        <p>${message}</p>
      </div>
      <div class="confirm-footer">
        <button class="confirm-btn ${cancelClass}" data-action="cancel">${cancelText}</button>
        <button class="confirm-btn ${confirmClass}" data-action="confirm">${confirmText}</button>
      </div>
    `
    
    overlay.appendChild(modal)
    document.body.appendChild(overlay)
    
    // Trigger animation
    setTimeout(() => {
      overlay.classList.add('confirm-show')
    }, 10)
    
    // Handle button clicks
    const handleClick = (e) => {
      const button = e.target.closest('.confirm-btn')
      if (button) {
        const action = button.dataset.action
        closeModal()
        resolve(action === 'confirm')
      }
    }
    
    // Close modal
    const closeModal = () => {
      overlay.classList.remove('confirm-show')
      setTimeout(() => {
        if (overlay.parentNode) {
          overlay.parentNode.removeChild(overlay)
        }
      }, 200)
    }
    
    // Handle overlay click (close on background click)
    overlay.addEventListener('click', (e) => {
      if (e.target === overlay) {
        closeModal()
        resolve(false)
      }
    })
    
    // Handle button clicks
    modal.addEventListener('click', handleClick)
    
    // Handle Escape key
    const handleEscape = (e) => {
      if (e.key === 'Escape') {
        closeModal()
        resolve(false)
        document.removeEventListener('keydown', handleEscape)
      }
    }
    document.addEventListener('keydown', handleEscape)
    
    // Focus the confirm button
    setTimeout(() => {
      const confirmBtn = modal.querySelector('[data-action="confirm"]')
      if (confirmBtn) confirmBtn.focus()
    }, 100)
  })
}
